import contentToEditorState from './contentToEditorState';

export default () => contentToEditorState({
    blocks: [{
        text: '',
    }],
    entityMap: {},
});
